import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';
import { AzureUploader } from '@bingads-webui/azure-upload';
import { ImageOData } from '@bingads-webui-campaign/image-odata';
import { getODataErrors as getODataErrorsImpl } from '@bingads-webui-campaign/api-errors';
import legacyOdata from '@bingads-webui-component-legacy/http/channel/odata';

import {
  getAIGCODataService,
  getFolderODataService,
  getImageBulkEditODataService,
  getVideoODataService
} from './odata-service';
import {
  getAIGCRepository,
  getFolderRepository,
  getRepository,
  getVideoRepository
} from './repository';

export const createAIGCRepository = ({ oDataConfig, aid, cid }) => {
  const aigcODataService = getAIGCODataService({
    odata, oDataConfig, aid, cid,
  });
  return getAIGCRepository({ aigcODataService });
};

export const createFolderRepository = ({
  logger, i18n, ianaTimeZone, timezoneUTCOffset, oDataConfig, aid, cid, dateFormat,
}) => {
  const azureUploader = new AzureUploader({
    logger: {
      trace: logger.traceWithoutParams,
    },
  });

  const folderODataService = getFolderODataService({
    odata,
    legacyOdata,
    oDataConfig,
    aid,
    cid,
    i18n,
    dateFormat,
  });

  return getFolderRepository({
    azureUploader,
    folderODataService,
    i18n,
    ianaTimeZone,
    timezoneUTCOffset,
    logger,
  });
};

export const createImageRepository = ({
  oDataConfig, aid, cid, logger, i18n, ianaTimeZone, timezoneUTCOffset, activity,
}) => {
  const imageBulkEditODataService =
    getImageBulkEditODataService({
      odata, oDataConfig, aid, cid, logger,
    });

  const imageODataService = new ImageOData(cid, aid, oDataConfig);

  const getODataErrors = (errs, defaultMessage) => {
    const errors = getODataErrorsImpl(errs, i18n, activity);
    if (!errors || _.isEmpty(errors)) {
      return defaultMessage;
    }
    return errors;
  };

  return getRepository({
    imageBulkEditODataService,
    imageODataService,
    i18n,
    ianaTimeZone,
    timezoneUTCOffset,
    getODataErrors,
  });
};

export const createVideoRepository = ({ oDataConfig, aid, cid }) => {
  const videoODataService = getVideoODataService({
    odata, oDataConfig, aid, cid,
  });
  return getVideoRepository({ videoODataService });
};
